import React from 'react';

/**
 * Label/value rows in the light-blue summary box (plan summary, success
 * details, manage details). `rows`: [{ label, value, indent? }] — value may
 * be a node; `indent` nests the row (fee/discount/total breakdown lines).
 */
const SummaryBox = ({ rows, white = false }) => (
	<div
		className={`flex w-full flex-col gap-[11px] rounded-[14px] border border-[#d5d7da] px-[16px] py-[14px] ${
			white ? 'bg-white' : 'bg-[#f6fbff]'
		}`}
	>
		{rows
			.filter((row) => row.value !== null && row.value !== undefined)
			.map((row) => (
				<div
					key={row.label}
					className={`flex w-full items-center justify-between gap-[12px] text-[13px] ${row.indent ? 'pl-[16px]' : ''}`}
				>
					<p className="text-[#7d7d7d]">{row.label}</p>
					<div className="text-right font-semibold text-[#16181d]">{row.value}</div>
				</div>
			))}
	</div>
);

export default SummaryBox;
